export const DEFAULT_LOCALE_UNDERSCORE = 'en_US';
export const DEFAULT_LOCALE_DASH = DEFAULT_LOCALE_UNDERSCORE.replace('_', '-');

export function getFinalLocale(calculatedLocale?: string | null): string {
  const normalizedLocale = calculatedLocale?.trim();
  return normalizedLocale ? normalizedLocale : DEFAULT_LOCALE_UNDERSCORE;
}
